/**
 * Declarative rules for Bugsnag events that should not be reported.
 * Each rule matches when ALL of its defined criteria match the event.
 *
 * @typedef {Object} IgnoredBugsnagErrorRule
 * @property {string} id - Stable identifier (for docs and debugging)
 * @property {string|RegExp} [message] - Exact message or regex
 * @property {string|RegExp} [errorClass] - e.g. 'TypeError', 'Error'
 * @property {string|string[]} [stackIncludes] - Substring(s) in any stack frame file or method
 */

/** @type {IgnoredBugsnagErrorRule[]} */
export const IGNORED_BUGSNAG_ERRORS = [
    {
        id: 'userflow-cdn-load-failure',
        message: 'Could not load Userflow.js',
        stackIncludes: 'userflow',
    },
    {
        id: 'ag-grid-size-columns-to-fit-race',
        message: /Cannot read properties of undefined \(reading 'sizeColumnsToFit'\)/,
        stackIncludes: 'DataGrid',
    },
];
